import { createSelector } from 'reselect'

const getMarketsStateSelector = state => state.markets

export const getMarketsDataSelector = createSelector(
  [getMarketsStateSelector, (_, entity) => entity],
  (markets, entity) => markets[entity]
)

export const getMarketsFetchingStatusSelector = createSelector(
  getMarketsStateSelector,
  markets => markets.isFetching
)

export const getMarketsFailedStatusSelector = createSelector(
  getMarketsStateSelector,
  markets => markets.isFailed
)

export const getMarketsCurrencySelector = createSelector(
  getMarketsStateSelector,
  markets => markets.marketsCurrency
)
